const warrantyMap = new Map([
  ["846171495", "39800680218695"], //heavy-duty-track-actuator
  ["849561087", "39800680251463"],
  ["849561459", "39800680284231"],
  ["849561947", "39800680316999"],
  ["849562179", "39800680349767"],
  ["849562375", "39800680382535"],
  ["849564131", "39800680415303"],
  ["849564135", "39800680448071"],
  ["849564139", "39800680480839"],
  ["849564143", "39800680513607"],
  ["39421953343559","39802541277255"], //adjustable-stroke-linear-actuators
  ["39421953409095", "39802541310023"],
  ["39421953441863", "39802541342791"],
  ["39421953474631", "39802541375559"],
  ["39499594498119", "39802541408327"],
  ["39421953507399", "39802541441095"],
  ["39499594661959", "39802541473863"],
  ["39421953540167", "39802541506631"],
  ["39499595022407", "39802541539399"],
  ["39421953572935", "39802541572167"],
  ["39499595153479", "39802541604935"],
  ["39421953605703", "39802541637703"],
  ["39421953671239", "39802541670471"],
  ["39421953736775", "39802541703239"],
  ["39421953769543", "39802541736007"],
  ["39499595382855", "39802541768775"],
  ["39499595644999", "39802541801543"],
  ["39421953835079", "39802541834311"],
  ["39499595874375", "39802541867079"],
  ["39421953867847", "39802541899847"],
  ["39499595907143", "39802541932615"],
  ["39421953900615", "39802541965383"],
  ["39499595055175", "39802541998151"],
  ["39421953933383", "39802542030919"],
  ["39421953998919", "39802542063687"],
  ["39421954064455", "39802542096455"],
  ["39421954097223", "39802542129223"],
  ["39421954129991", "39802542161991"],
  ["39499596070983", "39802542194759"],
  ["39421954162759", "39802542227527"],
  ["39499596103751", "39802542260295"],
  ["39421954195527", "39802542293063"],
  ["39499596169287", "39802542325831"],
  ["39421954228295", "39802542358599"],
  ["39499596234823", "39802542391367"],
  ["39421954261063", "39802542424135"],
  ["843861163", "39811049488455"], //linear-actuators
  ["843903175", "39811052404807"],
  ["843904247", "39811052437575"],
  ["843909131", "39811052470343"],
  ["843909371", "39811052503111"],
  ["843909667", "39811052535879"],
  ["843905379", "39811052568647"],
  ["843905623", "39811052601415"],
  ["843905943", "39811052634183"],
  ["8421679875", "39811052666951"],
  ["843918263", "39811052699719"],
  ["843926559", "39811052732487"],
  ["843926583", "39811052765255"],
  ["843926587", "39811052798023"],
  ["843926591", "39811052830791"],
  ["843926567", "39811052863559"],
  ["843926571", "39811052896327"],
  ["843926575", "39811052929095"],
  ["843940555", "39811052961863"],
  ["843940559", "39811052994631"],
  ["843940567", "39811053027399"],
  ["843940587", "39811053060167"],
  ["843940595", "39811053092935"],
  ["843940599", "39811053125703"],
  ["843940571", "39811053158471"],
  ["843940579", "39811053191239"],
  ["843940583", "39811053224007"], 
  ["3238183491", "39811053256775"],
  ["6270939523", "39811053289543"],
  ["32744221409351", "39811053322311"],
  ["7594426243", "39811053355079"],
  ["1227773563", "39811107225671"], //heavy-duty
  ["833075895", "39811107258439"],
  ["833087679", "39811107291207"],
  ["833092091", "39811107323975"],
  ["833093219", "39811107356743"],
  ["833095675", "39811107389511"],
  ["833096847", "39811107422279"],
  ["17424008390", "39811107455047"],
  ["833097343", "39811107487815"],
  ["833097467", "39811107520583"],
  ["15872134840391", "39811107553351"],
  ["833098795", "39811107586119"],
  ["833102423", "39811107618887"],
  ["833102431", "39811107651655"],
  ["833102439", "39811107684423"],
  ["833102447", "39811107717191"],
  ["833097007", "39811107749959"],
  ["833102451", "39811107782727"],
  ["833102455", "39811107815495"],
  ["39718588317767", "39813336334407"], //utility-linear-actuators
  ["39718588383303", "39813336399943"],
  ["39718588448839", "39813336465479"],
  ["39718588514375", "39813336531015"],
  ["39718588579911", "39813336596551"],
  ["39718588645447", "39813336662087"],
  ["39718588350535", "39813336367175"],
  ["39718588416071", "39813336432711"],
  ["39718588481607", "39813336498247"],
  ["39718588547143", "39813336563783"],
  ["39718588612679", "39813336629319"],
  ["39718588678215", "39813336694855"],
  ["11256347846", "39813363793991"], //premium-linear-actuators
  ["11256347910", "39813363826759"],
  ["11256347974", "39813363859527"],
  ["11256348038", "39813363892295"],
  ["11256348102", "39813363925063"],
  ["11256348166", "39813363957831"],
  ["11256348230", "39813363990599"],
  ["11256348294", "39813364023367"],
  ["11256348358", "39813364056135"],
  ["11256348422", "39813364088903"],
  ["11256348486", "39813364121671"],
  ["11256348550", "39813364154439"],
  ["11256348678", "39813364187207"],
  ["11256348742", "39813364219975"],
  ["11256348806", "39813364252743"],
  ["11256348870", "39813364285511"],
  ["11256348934", "39813364318279"],
  ["11256348998", "39813364351047"],
  ["11256349062", "39813364383815"],
  ["11256349126", "39813364416583"],
  ["11256349190", "39813364449351"],
  ["11256349254", "39813364482119"],
  ["11256349318", "39813364514887"],
  ["11256349382", "39813364547655"],
  ["11256349446", "39813364580423"],
  ["11256349510", "39813364613191"],
  ["11256349574", "39813364645959"],
  ["11256349702", "39813364678727"],
  ["11256349766", "39813364711495"],
  ["11256349830", "39813364744263"],
  ["12265428934", "39813512331335"], //premium-high-force-linear-actuators
  ["12265429062", "39813512364103"],
  ["12265429190", "39813512396871"],
  ["12265429254", "39813512429639"],
  ["12265429318", "39813512462407"],
  ["12265429382", "39813512495175"],
  ["12265429446", "39813512527943"],
  ["12265429510", "39813512560711"],
  ["846035963", "39813606178887"], //feedback-rod-actuator
  ["17445794414663", "39813606211655"],
  ["849524071", "39813606244423"],
  ["849524383", "39813606277191"],
  ["849524571", "39813606309959"],
  ["849524751", "39813606342727"],
  ["849541167", "39813606375495"],
  ["17445796872263", "39813606408263"],
  ["849541171", "39813606441031"],
  ["849541179", "39813606473799"],
  ["849541183", "39813606506567"],
  ["849541187", "39813606539335"],
  ["849545823", "39813606572103"],
  ["17445807194183", "39813606604871"],
  ["2632675779", "39813606637639"],
  ["2632742851", "39813606670407"],
  ["2632762115", "39813606703175"],
  ["2632767555", "39813606735943"],
  ["30260134969415", "39813607161927"],
  ["30260142768199", "39813607227463"],
  ["962605491", "39813719064647"], //deluxe-rod-actuator
  ["846147895", "39813719097415"],
  ["846307103", "39813719130183"],
  ["846310035", "39813719162951"],
  ["20140869830", "39813719195719"],
  ["846310659", "39813719228487"],
  ["846310939", "39813719261255"],
  ["846311507", "39813719294023"],
  ["6320007107", "39813719326791"],
  ["32035148202055", "39813719359559"],
  ["6320018115", "39813719392327"],
  ["1048046859", "39813733679175"], //industrial-heavy-duty-linear-actuators
  ["1048054671", "39813733711943"],
  ["1048064823", "39813733744711"],
  ["1048076571", "39813733777479"],
  ["1048076771", "39813733810247"],
  ["32395039408199", "39813733843015"],
  ["7635941763", "39813733875783"],
  ["7635942083", "39813733908551"],
  ["7635942403", "39813733941319"],
  ["7635942659", "39813733974087"],
  ["7635943043", "39813734006855"],
  ["32395039899719", "39813734039623"],
  ["846089703", "39813955878983"],//high-speed-actuator
  ["849373803", "39813955911751"],
  ["874881939", "39813955944519"],
  ["874882103", "39813955977287"],
  ["849374047", "39813956010055"],
  ["849374103", "39813956042823"],
  ["849374163", "39813956075591"],
  ["5384208387", "39813956108359"],
  ["849374327", "39813956141127"],
  ["849374395", "39813956173895"],
  ["849374507", "39813956206663"],
  ["1444327171", "39813956239431"],
  ["1444336835", "39813956272199"],
  ["846220983", "39816295874631"], //mini-track-actuator
  ["849586427", "39816295907399"],
  ["849586843", "39816295940167"],
  ["849586971", "39816295972935"],
  ["849587023", "39816296005703"],
  ["16326698041415", "39816381530183"], //optical-sensor-actuators
  ["39358073307207","39816381562951"],
  ["16326698074183","39816381595719"],
  ["39358073897031","39816381628487"],
  ["16326698106951","39816381661255"],
  ["16326698139719","39816381694023"],
  ["16326698172487","39816381726791"],
  ["16326698205255","39816381759559"],
  ["16326698238023","39816381792327"],
  ["16326698270791","39816381825095"],
  ["39505639145543","39816381857863"],
  ["39358074191943","39816381890631"],
  ["16326698303559","39816381923399"],
  ["39358074585159","39816381956167"],
  ["16326698336327","39816381988935"],
  ["16326698369095","39816382021703"],
  ["16326698401863","39816382054471"],
  ["16326698434631","39816382087239"],
  ["16326698467399","39816382120007"],
  ["16326698500167","39816382152775"],
  ["39358074716231","39816382185543"],
  ["16326698532935","39816382218311"],
  ["39358077173831","39816382251079"],
  ["16326698565703","39816382283847"],
  ["16326698598471","39816382316615"],
  ["16326698631239","39816382349383"],
  ["16326698664007","39816382382151"],
  ["16326698696775","39816382414919"],
  ["16326698729543","39816382447687"],
  ["846020099", "39816596029511"], //tubular-linear-actuator
  ["849589111", "39816596062279"],
  ["849589219", "39816596095047"],
  ["849589343", "39816596127815"],
  ["849589439", "39816596160583"],
  ["849589575", "39816596193351"],
  ["849589703", "39816596226119"],
  ["849590303", "39816596291655"],
  ["849590307", "39816596324423"],
  ["849590311", "39816596357191"],
  ["849590315", "39816596389959"],
  ["849590319", "39816596422727"],
  ["849590323", "39816596455495"],
  ["849590327", "39816596488263"],
  ["7900249859", "39816596521031"],
  ["843954091", "39822345404487"], //mini-linear-actuator
  ["843976559", "39822345437255"],
  ["843977023", "39822345470023"],
  ["843977311", "39822345502791"],
  ["843977859", "39822345535559"],
  ["843978175", "39822345568327"],
  ["20791982150", "39822366113863"], //bullet-series-mini-actuators
  ["20791982214", "39822366146631"],
  ["20791982278", "39822366179399"],
  ["20791982342", "39822366212167"],
  ["20791982406", "39822366244935"],
  ["20791982470", "39822366277703"],
  ["20791982534", "39822366310471"],
  ["20791982598", "39822366343239"],
  ["20791982662", "39822366376007"],
  ["20791982726", "39822366408775"],
  ["20791982790", "39822366441543"],
  ["20791982854", "39822366474311"],
  ["20791982918", "39822366507079"],
  ["20791982982", "39822366539847"],
  ["20791983046", "39822366572615"],
  ["20791983174", "39822366605383"],
  ["20791983302", "39822366638151"],
  ["20791983366", "39822366670919"],
  ["20791983558", "39822366703687"],
  ["20791983686", "39822366736455"],
  ["20791983750", "39822366769223"],
  ["20791983814", "39822366801991"],
  ["20791983878", "39822366834759"],
  ["20791983942", "39822366867527"],
  ["20791984006", "39822366900295"],
  ["20791984070", "39822366933063"],
  ["20791984134", "39822366965831"],
  ["20791984262", "39822366998599"],
  ["20791984326", "39822367031367"],
  ["20791984390", "39822367064135"],
  ["20791984454", "39822367096903"],
  ["20791984518", "39822367129671"],
  ["32461911949383", "39822677737543"], //bullet-series-50-cal-linear-actuators
  ["32461911982151", "39822677770311"],
  ["32461912014919", "39822677803079"],
  ["32461912047687", "39822677835847"],
  ["32461912080455", "39822677868615"],
  ["32461912113223", "39822677901383"],
  ["32461912145991", "39822677934151"],
  ["32461912178759", "39822677966919"],
  ["32461912211527", "39822677999687"],
  ["16273143955527", "39822678032455"],
  ["16273291411527", "39822678065223"],
  ["16273291444295", "39822678097991"],
  ["16273291477063", "39822678130759"],
  ["16273291509831", "39822678163527"],
  ["16273291542599", "39822678196295"],
  ["16273291575367", "39822678229063"],
  ["16273291608135", "39822678261831"],
  ["16273291640903", "39822678294599"],
  ["16273291673671", "39822678327367"],
  ["16273291706439", "39822678360135"],
  ["16273291739207", "39822678392903"],
  ["16273291771975", "39822678425671"],
  ["16273291804743", "39822678458439"],
  ["16273291837511", "39822678491207"],
  ["16273291870279", "39822678523975"],
  ["16273291903047", "39822678556743"],
  ["16273291935815", "39822678589511"],
  ["32461912244295", "39822678622279"],
  ["32461912277063", "39822678655047"],
  ["32461912309831", "39822678687815"],
  ["32461912342599", "39822678720583"],
  ["32461912375367", "39822678753351"],
  ["32461912408135", "39822678786119"],
  ["32461912440903", "39822678818887"],
  ["32461912473671", "39822678851655"],
  ["32461912506439", "39822678884423"],
  ["16273291968583", "39822678917191"],
  ["16273292001351", "39822678949959"],
  ["16273292034119", "39822678982727"],
  ["16273292066887", "39822679015495"],
  ["16273292099655", "39822679048263"],
  ["16273292132423", "39822679081031"],
  ["16273292165191", "39822679113799"],
  ["16273292197959", "39822679146567"],
  ["16273292230727", "39822679179335"],
  ["16273292263495", "39822679212103"],
  ["16273292296263", "39822679244871"],
  ["16273292329031", "39822679277639"],
  ["16273292361799", "39822679310407"],
  ["16273292394567", "39822679343175"],
  ["16273292427335", "39822679375943"],
  ["16273292460103", "39822679408711"],
  ["16273292492871", "39822679441479"],
  ["16273292525639", "39822679474247"],
  ["9623269827", "39824477061191"], //heavy-duty-linear-actuator-ip66
  ["1212506435", "39824477093959"],
  ["1212506791", "39824477126727"],
  ["1212507043", "39824477159495"],
  ["959746799", "39824477192263"],
  ["959746207", "39824477225031"],
  ["15587090822", "39824477257799"],
  ["1190643379", "39824539320391"], //electric-column-lift
  ["1190646895", "39824539353159"],
  ["16272871129159", "39825399906375"], //bullet-series-36-cal-linear-actuators
  ["16273039818823", "39825399939143"],
  ["16273039851591", "39825400004679"],
  ["16273039884359", "39825400102983"],
  ["16273039917127", "39825400168519"],
  ["16273039949895", "39825400234055"],
  ["16273039982663", "39825400299591"],
  ["16273040015431", "39825400397895"],
  ["16273040048199", "39825400463431"],
  ["16273040080967", "39825400528967"],
  ["16273040113735", "39825400627271"],
  ["16273040146503", "39825400692807"],
  ["16273040179271", "39825400758343"],
  ["16273040212039", "39825400823879"],
  ["16273040244807", "39825400889415"],
  ["16273040277575", "39825400987719"],
  ["16272433971271", "39825679089735"], //bullet-series-23-cal
  ["16272471556167", "39825679122503"],
  ["16272471588935", "39825679155271"],
  ["16272471621703", "39825679188039"],
  ["16272471654471", "39825679220807"],
  ["16272471687239", "39825679253575"],
  ["16272471720007", "39825679286343"],
  ["16272471752775", "39825679319111"],
  ["16272471785543", "39825679351879"],
  ["16272471818311", "39825680793671"],
  ["16272471851079", "39825680826439"],
  ["16272471883847", "39825680859207"],
  ["16272471916615", "39825680891975"],
  ["16272471949383", "39825680924743"],
  ["16272471982151", "39825680957511"],
  ["16272472014919", "39825680990279"],
  ["16272472047687", "39825681023047"],
  ["16272472080455", "39825681055815"],
  ["39510138585159", "39826216288327"], //bullet-series-35-cal-linear-actuators
  ["39510138617927", "39826216321095"],
  ["39510138650695", "39826216353863"],
  ["39510138683463", "39826216386631"],
  ["39510138716231", "39826216419399"],
  ["39510138748999", "39826216452167"],
  ["39510138781767", "39826216484935"],
  ["39510138814535", "39826216517703"],
  ["39510222307399", "39826216550471"],
  ["39510222700615", "39826216583239"],
  ["39510222766151", "39826216616007"],
  ["39510222798919", "39826216648775"],
  ["39510222995527", "39826216681543"],
  ["39510223192135", "39826216714311"],
  ["39510224535623", "39826216747079"],
  ["39510224568391", "39826216779847"],
  ["39510224633927", "39826216812615"],
  ["39510224699463", "39826216845383"],
  ["39510225682503", "39826216878151"],
  ["39510225748039", "39826216910919"],
  ["39510225879111", "39826216943687"],
  ["39510225911879", "39826216976455"],
  ["39510225944647", "39826217009223"],
  ["39510225977415", "39826217041991"],
  ["41522726437062", "39827562823751"], //micro-pen-actuators-12v
  ["41522726469830", "39827562856519"],
  ["41522726502598", "39827562889287"],
  ["41522726535366", "39827562922055"],
  ["41522726568134", "39827562954823"],
  ["41522726600902", "39827562987591"],
  ["41522726633670", "39827563020359"],
  ["41522726666438", "39827563053127"],
  ["41522726699206", "39827563085895"],
  ["41522726731974", "39827563118663"],
  ["39576067670087", "39827576422471"], //silent-micro-linear-actuator
  ["39576067702855", "39827576455239"],
  ["39576067735623", "39827576488007"],
  ["39576067768391", "39827576520775"],
  ["39576067801159", "39827576553543"],
  ["39576067833927", "39827576586311"],
  ["39576067866695", "39827576619079"],
  ["39576067899463", "39827576651847"],
  ["39574554083399", "39827601293383"], //f12-micro-linear-actuators
  ["39574554116167", "39827601326151"],
  ["39574554148935", "39827601358919"],
  ["39574554181703", "39827601391687"],
  ["39574554214471", "39827601424455"],
  ["39574554247239", "39827601457223"],
  ["39514433388615", "39827650379847"], //micro-actuators
  ["39514433421383", "39827650412615"],
  ["39553061879879", "39827650445383"],
  ["39514433454151", "39827650478151"],
  ["39514433486919", "39827650510919"],
  ["39553061912647", "39827650543687"],
  ["39514433519687", "39827650576455"],
  ["39514433552455", "39827650609223"],
  ["39553061945415", "39827650641991"],
  ["39514433585223", "39827650674759"],
  ["39514433617991", "39827650707527"],
  ["39553061978183", "39827650740295"],
  ["39514433650759", "39827650773063"],
  ["39514433683527", "39827650805831"],
  ["39553062010951", "39827650838599"],
  ["39574419603527", "39827671154759"], //micro-actuators-12v
  ["39574419669063", "39827671187527"],
  ["39574419701831", "39827671220295"],
  ["39574419767367", "39827671253063"],
  ["39574419800135", "39827671285831"],
  ["39574419865671", "39827671318599"],
  ["39574419898439", "39827671351367"],
  ["39574419963975", "39827671384135"],
  ["39574419996743", "39827671416903"],
  ["39574420062279", "39827671449671"],
  ["1037043191", "39827718570055"], //potentiometer
  ["1037049991", "39827718602823"],
  ["1037053095", "39827718635591"],
  ["1037053467", "39827718668359"],
  ["1037053635", "39827718701127"],
  ["1037054359", "39827718733895"],
  ["1037054515", "39827718766663"],
  ["1037054739", "39827718799431"],
  ["1037055667", "39827718832199"],
  ["1037056171", "39827718864967"],
  ["795915855", "39850055630919"], //pop-up-tv-lift
  ["832492595", "39850055663687"],
  ["832497595", "39850055696455"],
  ["15184195462", "39850063986759"], //39-pop-up-tv-lift
  ["23270802054", "39850064019527"],
  ["23270802118", "39850064052295"],
  ["14879831622", "39850080141383"], //drop-down-tv-lift
  ["14879831686", "39850080174151"],
  ["14879831750", "39850080206919"],
  ["39544932204615", "39850080239687"],
  ["54866856533", "39853306249287"], //motorized-flip-down-tv-ceiling-mount
  ["31500906758215", "39853306282055"],
  ["20348506566", "39853339344967"], //outdoor-tv-lift-cabinet
  ["31724359417927", "39853339377735"],
  ["43498565589", "39853402128455"], //sit-stand-desk
  ["43498605845", "39853402161223"],
  ["874122727", "39853506199623"], //motorized-desk-lift
  ["13593549668423", "39853506265159"],
  ["874123495", "39853616365639"], //electric-table-lift
  ["15998015897671", "39853616398407"],
  ["874114411", "39853604470855"], //sit-stand-desk-lift
  ["30851422278", "39871280119879"], //treadmill-desk
  ["874104623", "39871289032775"], //two-channel-remote-control-system
  ["874106639", "39871321768007"], //four-channel-remote-control-system
  ["31598239252551", "39871370985543"], //synchronous-control-board
  ["31598239285319", "39871371018311"]                          
  


]);